import { NgModule } from '@angular/core';
import { AgGridFixServerSortingDirective } from './fix-server-sorting.directive';

const PUBLIC_DECLARATIONS = [
  AgGridFixServerSortingDirective,
];

@NgModule({
  declarations: [
    ...PUBLIC_DECLARATIONS,
  ],
  exports: [
    ...PUBLIC_DECLARATIONS,
  ],
})
export class AgGridFixServerSortingModule {
}
